export default {
  setTitle(title) {
    document.title = title  
  }
}
